export default __webpack_public_path__ + "static/media/prize-6-bm.27f95a91.webp";